/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { FileUploadResult } from '../models/file-upload-result';
import { Image } from '../models/image';
import { imagesControllerGetFileDataByIdWithName } from '../fn/images/images-controller-get-file-data-by-id-with-name';
import { ImagesControllerGetFileDataByIdWithName$Params } from '../fn/images/images-controller-get-file-data-by-id-with-name';
import { imagesControllerGetImageDataById } from '../fn/images/images-controller-get-image-data-by-id';
import { ImagesControllerGetImageDataById$Params } from '../fn/images/images-controller-get-image-data-by-id';
import { imagesControllerRemove } from '../fn/images/images-controller-remove';
import { ImagesControllerRemove$Params } from '../fn/images/images-controller-remove';
import { imagesControllerResizeAndStoreImageFile } from '../fn/images/images-controller-resize-and-store-image-file';
import { ImagesControllerResizeAndStoreImageFile$Params } from '../fn/images/images-controller-resize-and-store-image-file';
import { imagesControllerUploadFile } from '../fn/images/images-controller-upload-file';
import { ImagesControllerUploadFile$Params } from '../fn/images/images-controller-upload-file';
import { imagesControllerUploadFileBase64 } from '../fn/images/images-controller-upload-file-base-64';
import { ImagesControllerUploadFileBase64$Params } from '../fn/images/images-controller-upload-file-base-64';
import { ImageUploadResult } from '../models/image-upload-result';

@Injectable({ providedIn: 'root' })
export class ImagesService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `imagesControllerGetImageDataById()` */
  static readonly ImagesControllerGetImageDataByIdPath = '/images/get-image/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `imagesControllerGetImageDataById()` instead.
   *
   * This method doesn't expect any request body.
   */
  imagesControllerGetImageDataById$Response(params: ImagesControllerGetImageDataById$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = imagesControllerGetImageDataById(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `imagesControllerGetImageDataById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  imagesControllerGetImageDataById(params: ImagesControllerGetImageDataById$Params, context?: HttpContext): Observable<void> {
    const resp = this.imagesControllerGetImageDataById$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `imagesControllerGetFileDataByIdWithName()` */
  static readonly ImagesControllerGetFileDataByIdWithNamePath = '/images/get-image/{id}/{fileName}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `imagesControllerGetFileDataByIdWithName()` instead.
   *
   * This method doesn't expect any request body.
   */
  imagesControllerGetFileDataByIdWithName$Response(params: ImagesControllerGetFileDataByIdWithName$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = imagesControllerGetFileDataByIdWithName(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `imagesControllerGetFileDataByIdWithName$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  imagesControllerGetFileDataByIdWithName(params: ImagesControllerGetFileDataByIdWithName$Params, context?: HttpContext): Observable<void> {
    const resp = this.imagesControllerGetFileDataByIdWithName$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `imagesControllerUploadFile()` */
  static readonly ImagesControllerUploadFilePath = '/images/uploadFile';

  /**
   * upload a file.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `imagesControllerUploadFile()` instead.
   *
   * This method doesn't expect any request body.
   */
  imagesControllerUploadFile$Response(params?: ImagesControllerUploadFile$Params, context?: HttpContext): Observable<StrictHttpResponse<FileUploadResult>> {
    const obs = imagesControllerUploadFile(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * upload a file.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `imagesControllerUploadFile$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  imagesControllerUploadFile(params?: ImagesControllerUploadFile$Params, context?: HttpContext): Observable<FileUploadResult> {
    const resp = this.imagesControllerUploadFile$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<FileUploadResult>): FileUploadResult => r.body)
    );
  }

  /** Path part for operation `imagesControllerUploadFileBase64()` */
  static readonly ImagesControllerUploadFileBase64Path = '/images/uploadImageBase64';

  /**
   * upload a file as base64 string.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `imagesControllerUploadFileBase64()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  imagesControllerUploadFileBase64$Response(params: ImagesControllerUploadFileBase64$Params, context?: HttpContext): Observable<StrictHttpResponse<ImageUploadResult>> {
    const obs = imagesControllerUploadFileBase64(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * upload a file as base64 string.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `imagesControllerUploadFileBase64$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  imagesControllerUploadFileBase64(params: ImagesControllerUploadFileBase64$Params, context?: HttpContext): Observable<ImageUploadResult> {
    const resp = this.imagesControllerUploadFileBase64$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ImageUploadResult>): ImageUploadResult => r.body)
    );
  }

  /** Path part for operation `imagesControllerRemove()` */
  static readonly ImagesControllerRemovePath = '/images/{id}';

  /**
   * delete a file.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `imagesControllerRemove()` instead.
   *
   * This method doesn't expect any request body.
   */
  imagesControllerRemove$Response(params: ImagesControllerRemove$Params, context?: HttpContext): Observable<StrictHttpResponse<Image>> {
    const obs = imagesControllerRemove(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * delete a file.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `imagesControllerRemove$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  imagesControllerRemove(params: ImagesControllerRemove$Params, context?: HttpContext): Observable<Image> {
    const resp = this.imagesControllerRemove$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Image>): Image => r.body)
    );
  }

  /** Path part for operation `imagesControllerResizeAndStoreImageFile()` */
  static readonly ImagesControllerResizeAndStoreImageFilePath = '/images/resizeAndStoreImage';

  /**
   * resize the uploaded image file.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `imagesControllerResizeAndStoreImageFile()` instead.
   *
   * This method doesn't expect any request body.
   */
  imagesControllerResizeAndStoreImageFile$Response(params?: ImagesControllerResizeAndStoreImageFile$Params, context?: HttpContext): Observable<StrictHttpResponse<ImageUploadResult>> {
    const obs = imagesControllerResizeAndStoreImageFile(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * resize the uploaded image file.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `imagesControllerResizeAndStoreImageFile$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  imagesControllerResizeAndStoreImageFile(params?: ImagesControllerResizeAndStoreImageFile$Params, context?: HttpContext): Observable<ImageUploadResult> {
    const resp = this.imagesControllerResizeAndStoreImageFile$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ImageUploadResult>): ImageUploadResult => r.body)
    );
  }

}
